import { render } from "./GroupFullCard.vue?vue&type=template&id=10a6bad5"
import script from "./GroupFullCard.vue?vue&type=script&lang=js"
export * from "./GroupFullCard.vue?vue&type=script&lang=js"

import "./GroupFullCard.vue?vue&type=style&index=0&id=10a6bad5&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__